import { Theme, createStyles } from '@mui/material/styles';


export const styles = (theme: Theme) => createStyles({

    container: {
        backgroundColor: theme.palette.grey[200],
        margin: 0,
        padding: "10px",
        color: theme.palette.common.black,
    },
    columnMiddle: {
        flexGrow: 1,
        "& p": {
            fontSize: "0.775em",
            overflow: "hidden",
        },
    },
    columnRight: {
        justifyContent: "center",
        alignSelf: "flex-start"
    },

    sourceUrl: {
        fontSize: "0.775em",
        marginTop: 2,
        wordBreak: "break-word",
        color: theme.palette.grey[500],
    },

    imgLarge: {
        height: "128px"
    },
    imgSmall: {
        height: "64px"
    },

    title: {
        fontWeight: "bold"
    },

    author: {
        fontSize: ".7em",

        "&span > span:before":
        {
            content: " - "
        }
    },

    metainfo: {
        marginTop: 2,
        fontWeight: "bold",
        fontSize: ".775em"
    },

});
